import { useState } from "react";
import { Download, CheckCircle, X } from "react-feather";
import { Colors } from "../../../../values/colors";
import { Text } from "../../../../components/BaseComponents/styles";
import { FlatButton } from "../../../../components/BaseComponents/styles";
import {
  PanelContainer,
  PanelHeader,
  PanelTitle,
  PanelBody,
  OptionsBody,
  RadioOption,
  RadioCircle,
  OptionInfo,
  OptionTitle,
  OptionDesc,
  CategoriesSection,
  CategoriesLabel,
  CheckboxOption,
  CheckboxBox,
  CheckMark,
  DownloadBtn,
  SuccessWrapper,
  SuccessIconWrap,
  SuccessTitle,
  SuccessSubtext,
} from "./styles";
import RiskSurveyService from "../../../../services/RiskSurvey";

const CATEGORIES = [
  { id: 1, name: "Exigências ocupacionais" },
  { id: 2, name: "Ritmo de trabalho" },
  { id: 3, name: "Ambiente e papel laboral" },
  { id: 4, name: "Comunidade social no trabalho" },
  { id: 5, name: "Qualidade e confiança na liderança" },
  { id: 6, name: "Conflitos laborais" },
];

const pdfTypes = {
  general: "Relatório Geral",
  categories: "Relatório por Categoria"
};

const SuccessContent = () => (
  <SuccessWrapper>
    <SuccessIconWrap>
      <CheckCircle size={72} color={Colors.secondaryGreen} strokeWidth={1.5} />
    </SuccessIconWrap>
    <SuccessTitle>Download Iniciado!</SuccessTitle>
    <SuccessSubtext>
      O seu relatório está a ser gerado e será guardado no seu dispositivo em instantes.
    </SuccessSubtext>
  </SuccessWrapper>
);

export const DownloadReportModal = ({ survey, onClose, $align = "right", style }) => {
  const [reportType, setReportType] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState(new Set(CATEGORIES.map((c) => c.id)));
  const [downloaded, setDownloaded] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggleCategory = (id) => {
    setSelectedCategories((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const canDownload =
    reportType === "general" ||
    (reportType === "categories" && selectedCategories.size > 0);

  const handleDownload = async () => {
    if (!canDownload || loading) return;
    setLoading(true);
    try {

      let blob;
      if (reportType === "general") {
        blob = await RiskSurveyService.downloadGeneralPdf(survey.id);
      } else {
        blob = await RiskSurveyService.downloadCategoryPdf(survey.id, [...selectedCategories]);
      }

      const url = window.URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${survey.title} - ${pdfTypes[reportType]}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setDownloaded(true);
      
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PanelContainer $align={$align} style={style}>
      <PanelHeader>
        <PanelTitle>Opções de Exportação</PanelTitle>
        <FlatButton onClick={onClose}>
          <X size={15} color={Colors.mediumGray} />
        </FlatButton>
      </PanelHeader>

      <PanelBody>
        {downloaded ? (
          <SuccessContent />
        ) : (
          <OptionsBody>
            <RadioOption
              selected={reportType === "general"}
              onClick={() => setReportType("general")}
            >
              <RadioCircle selected={reportType === "general"} />
              <OptionInfo>
                <OptionTitle>Relatório Geral</OptionTitle>
                <OptionDesc>Visão consolidada de todos os dados.</OptionDesc>
              </OptionInfo>
            </RadioOption>

            <RadioOption
              selected={reportType === "categories"}
              onClick={() => setReportType("categories")}
              style={
                reportType === "categories"
                  ? { borderRadius: "8px 8px 0 0", marginBottom: 0 }
                  : {}
              }
            >
              <RadioCircle selected={reportType === "categories"} />
              <OptionInfo>
                <OptionTitle>Relatório por Categorias</OptionTitle>
                <OptionDesc>Relatório detalhado por categorias</OptionDesc>
              </OptionInfo>
            </RadioOption>

            {reportType === "categories" && (
              <CategoriesSection>
                <CategoriesLabel>Selecione as categorias:</CategoriesLabel>
                {CATEGORIES.map((cat) => (
                  <CheckboxOption key={cat.id} onClick={() => toggleCategory(cat.id)}>
                    <CheckboxBox checked={selectedCategories.has(cat.id)}>
                      {selectedCategories.has(cat.id) && <CheckMark />}
                    </CheckboxBox>
                    <Text size={12} color={Colors.blueGray}>
                      {cat.name}
                    </Text>
                  </CheckboxOption>
                ))}
              </CategoriesSection>
            )}

            <DownloadBtn disabled={!canDownload || loading} onClick={handleDownload}>
              <Download size={14} />
              {loading ? "Gerando..." : "Download"}
            </DownloadBtn>
          </OptionsBody>
        )}
      </PanelBody>
    </PanelContainer>
  );
};
